@if (question && formGroup) {
<div class="question-container">
  <form [formGroup]="formGroup">
    @switch (question.type) {
    <!--  -->
    @case (FeedbackQuestionType.TEXT){
    <!-- text question -->
    <motif-form-field>
      <textarea
        motifInput
        formControlName="textInput"
        class="answer-textarea"
        [attr.placeholder]="question.input_box_default_text"
      ></textarea>
    </motif-form-field>

    }
    <!--  -->
    @case (FeedbackQuestionType.CHOICE){
    <!-- choice question -->
    <p class="question-label">Please select the option that applies</p>

    @if(optionFormGroups){
    <!--  -->
    @for (option of question.options; let i = $index; track $index) {
    <div #optionContainer class="option-container">
      <motif-form-field [formGroup]="optionFormGroups[i]">
        <motif-checkbox
          #optionCheckbox
          formControlName="optionChecked"
          (change)="onOptionCheckboxChange(i, $event)"
        >
          @if (option.label) {
          <span class="option-label"> {{ option.label }}: </span>
          } {{ option.text }}</motif-checkbox
        >
      </motif-form-field>

      @if (option.text_input_type != FeedbackTextType.NONE){
      <div class="option-text-input-container">
        <motif-form-field [formGroup]="optionFormGroups[i]">
          <!-- Leaving the input here just in case we want to get back to it -->
          <!-- <input
            motifInput
            type="text"
            formControlName="textInput"
            class="option-textarea"
            [attr.placeholder]="option.input_box_default_text"
          /> -->
          <textarea
            motifInput
            type="text"
            formControlName="textInput"
            class="option-textarea"
            [attr.placeholder]="option.input_box_default_text"
          ></textarea>
        </motif-form-field>
      </div>
      }
    </div>
    }
    <!-- END @for question.options  -->
    }
    <!-- END @if optionFormGroups -->
    }
    <!-- END @case FeedbackQuestionType.CHOICE -->

    @case (FeedbackQuestionType.CHOICE_AND_TEXT) {
    <!-- TODO choice and text question -->

    }
    <!-- END @case FeedbackQuestionType.CHOICE_AND_TEXT  -->
    }
  </form>
</div>
}
